import React from 'react';
import classes from './WaveSection.module.css';

const WaveSection = ({ children, mask=1, globalClasses = "", maskClasses = "", contentClasses = "" }) => {
    
    
    return (
        <div className={`${classes.WaveSection} ${globalClasses}`}>
            <div className={`${classes.waveMask} ${classes["mask_" + mask]} ${maskClasses}`}>
            </div>
            <div className={`${classes.waveContent} ${contentClasses}`}>
                {children}
            </div>
        </div>
    );
};



export default WaveSection;